import { getLinkDetailsEnterprise } from "@/utils/utilities";
import Link from "next/link";
import { globalConstants } from "@/constants/globalConstants";


const CartWrapper = ({
  cartGroup,
  rightNavigation,
  // mobileLocationLinks,s
  // mobileSelectLocationLink,
}) => {

  const { HEADER_TEXT } = globalConstants.thecapitalgrille
  const [findLoc, changeLoc, login] = rightNavigation || [];
  const { IMAGES } = globalConstants?.olivegarden || {};

  const findLocationDetails = findLoc ? getLinkDetailsEnterprise(findLoc) : {};
  const changeLocationDetails = changeLoc ? getLinkDetailsEnterprise(changeLoc) : {};
  const loginDetails = login ? getLinkDetailsEnterprise(login) : {};

  // const [mobileMoreDetail, mobileChangeLocation] = mobileLocationLinks || [];

  // const mobileMoreDetails = mobileMoreDetail ? getLinkDetailsEnterprise(mobileMoreDetail) : {};
  // const mobileChangeLocationDetails = mobileChangeLocation ? getLinkDetailsEnterprise(mobileChangeLocation) : {};


  const cartLogo = cartGroup?.cart_logo?.[0] || {};
  const links = cartGroup?.links || [];
  return (
    <div className="cart-location-wrapper">
      <div className="d-flex align-items-center justify-content-end column-gap-3">
        <div className="cart-location-item d-none d-lg-block">
          <div id="no-location-selected">
            <a
              href={findLocationDetails?.linkUrl}
              className="cart-location-link font-neulis-neus trackContent"
              
            >
              <span className="ae-compliance-indent sr-only" style={{ display: "none" }}>
                Location information including phone numbers may be found
              </span>
              {/*<img src="./assets/olivegarden/images/location_icon.svg" alt="Location Icon" />*/}
              {findLocationDetails?.linkTitle}
            </a>
          </div>
          <div
            id="selected-location"
            className="active-location"
            style={{ display: "none" }}
          >
            <div className="header-location-name d-flex align-items-center column-gap-2" id="desktop-location-link-trigger">
              <a
                id="header-location-name"
                href=""
                role="button"
                tabIndex="0"
                aria-expanded="false"
              >
              </a>
              <span className="arrow arrow-down" id="location-show-arrow" role="button" tabIndex="0"></span>

            </div>

            <div
              className="header-location-number"
              id="header-location-number"
            ></div>
            <a
              className="header-change-location-link tertiary-font-color text-uppercase trackContent"
              href={changeLocationDetails?.linkUrl}
              role={changeLocationDetails?.role}
              tabIndex="0"
              aria-expanded="false"
              
            >
              {changeLocationDetails?.linkTitle}
              <span className="ae-compliance-indent" style={{ display: "none" }}>
                Location information including phone numbers may be found
              </span>
            </a>

          </div>
        </div>
        <ul className="cart-location d-flex align-items-center list-unstyled m-0">
          <li
            className="cart-location-item log-in-link login-wrapper d-none d-lg-flex flex-column"
            id="responsiveLoginLink"
          >
            <a
              href={loginDetails?.linkUrl}
              className="cart-location-link trackContent" data-link-info={loginDetails?.dataLinkInfo}
            >
              {loginDetails?.linkTitle}
            </a>
          </li>
          <li className="cart-location-item cart-location-item__pin map-pin d-lg-none">
            <button
              id="mobile-location-link-trigger"
              className="cart-location-link mobile-location-link ae-button bg-transparent border-0 p-0 m-0 trackContent"
              aria-controls="mobile-location-information"
              aria-expanded="false"
              data-ae-blurbtype="button"
              data-ae-form-field="true"
              data-link-info="hamburger|location"
            >
              <img
                src={IMAGES?.LOCATION_ICON.IMAGE_URL}
                alt={IMAGES?.LOCATION_ICON?.IMAGE_ALT}
                aria-hidden="true"
                className="img-block img-fluid img-pin"
                id="mobile-location-link-trigger-icon"
              />
              <span className="visually-hidden sr-only">Change or Find location</span>
            </button>

          </li>

          <li className="cart-location-item cart-location-item__shopping-bag">
            <a
              href="#"
              id="cart-location-trigger"
              className="cart-location-link trackContent"
              aria-controls="cart-empty-popup"
              aria-expanded="false"
              data-link-info="header|cart icon|cart cta"
            >
              {cartLogo?.desktop_image?.href && (
                <img

                  src={IMAGES?.CART_ICON.IMAGE_URL}
                  alt={cartLogo?.desktop_image?.title}
                  aria-hidden="true"
                  className="ae-img-cart img-cart"
                />
              )}
              {cartLogo?.desktop_image.title && (
                <span className="visually-hidden sr-only">
                  {cartLogo?.desktop_image?.title}
                </span>
              )}
              {/* IMPORTANT: .sr-only is BS Accessibility class. DO NOT add styles to it*/}
              <span className="cart-item-count" style={{ display: "none" }}>
                {HEADER_TEXT.CART_COUNT}<span className="visually-hidden sr-only">items in cart</span>
              </span>
              {/* Dynamically add class 'double-digit' if the number is < 10 */}
            </a>

            <div
              id="cart-empty-popup"
              className="cart-empty-popup light-background"
              aria-hidden="false" style={{ display: "none" }}

            >
              <div className="cart-empty__header">
                {cartGroup?.heading && (

                  <h4>{cartGroup?.heading}</h4>

                )}
              </div>
              <div className="cart-empty__content p-3">
                {cartGroup?.description && (
                  <p>
                    {cartGroup?.description}
                  </p>
                )}

                <div className="d-flex flex-column gap-4">
                  {Array.isArray(links) &&
                    links?.map((link) => {
                      const { linkTitle, linkUrl, linkTarget, dataLinkInfo, linkID } = getLinkDetailsEnterprise(link);
                      if (!linkTitle || !linkUrl) return null;
                      return (
                        <a
                          key={link?.uid}
                          href={linkUrl}
                          target={linkTarget}
                          className="btn btn-light-green trackContent"
                          data-link-info={dataLinkInfo}
                          id={linkID}
                          
                        >
                          {linkTitle}
                        </a>
                      );
                    })}
                </div>

                <button
                  id="close-cart-empty-popup"
                  className="close-cart-empty modal-close-button button-reset ae-button"
                  data-ae-blurbtype="button"
                  data-ae-form-field="true"
                >
                  <img
                    className="cart-empty-popup-close-btn ae-img"
                    src="https://media.olivegarden.com/images/OG_Redesign_Assets/Icons/Cross_White.svg"
                    alt="Close Cart Popup"
                  />
                </button>

              </div>


            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CartWrapper;
